import { COMPANY_NAME, COMPANY_EMAIL, COMPANY_URL, COPYRIGHT_YEAR } from '../../shared/constants';

function Footer() {
  return (
    <div style={styles.footer}>
      <div>
        © {COPYRIGHT_YEAR}{' '}
        <a
          href={COMPANY_URL}
          style={styles.footerLink}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#b91c1c')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#dc2626')}
        >
          {COMPANY_NAME}
        </a>{' '}
        — All rights reserved.
      </div>
      <div>
        Contact:{' '}
        <a
          href={`mailto:${COMPANY_EMAIL}`}
          style={styles.footerLink}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#b91c1c')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#dc2626')}
        >
          {COMPANY_EMAIL}
        </a>
      </div>
    </div>
  );
}

export default Footer;

const styles = {
  footer: {
    padding: '40px 20px',
    textAlign: 'center' as const,
    background: 'rgba(255, 255, 255, 0.5)',
    borderTop: '1px solid #e2e8f0',
    color: '#64748b',
    fontSize: '0.9rem',
    lineHeight: '1.8',
  },

  footerLink: {
    color: '#dc2626',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
  },
};
